/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconSignal4g = createReactComponent("outline", "signal-4g", "IconSignal4g", [["path", { "d": "M6 8v3a1 1 0 0 0 1 1h3", "key": "svg-0" }], ["path", { "d": "M10 8v8", "key": "svg-1" }], ["path", { "d": "M17 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1", "key": "svg-2" }]]);

export { IconSignal4g as default };
//# sourceMappingURL=IconSignal4g.mjs.map
